import PropTypes from 'prop-types';
import {I18n, Translate} from 'react-redux-i18n';
import {Collapse} from '@material-ui/core';
import ReadOnlyDocumentsList from '../../../readOnlyDocumentList';

function ReminderView(props) {
  const {reminder} = props;

  return (
    <div className={`document-card${props.isOpen ? ' open' : ''}`}>
      <div
        className="main d-flex justify-content-between"
        onClick={props.onOpenReminder}
      >
        <h3 className="m-0">
          <Translate
            value="document.remind.description.dateFrom"
            date={I18n.l(reminder.remindDate, {dateFormat: 'datetime.shortDate'})}
          />
        </h3>
        <span
          className="caret-drop"
          style={{height: 12, width: 12}}
        ></span>
      </div>
      <Collapse in={props.isOpen}>
        <div className="collapse">
          <hr className="mt-0 mb-4"/>
          <div>
            <div className="row mt-4">
              <div className="col-md-6 my-2">
                <span>
                  <strong><Translate value="document.remind.description.projectName"/></strong>
                  <span data-id="projectName"> {reminder.projectName}</span>
                </span>
              </div>
              <div className="col-md-6 my-2">
                <span>
                  <strong><Translate value="document.remind.description.reason.title"/></strong>
                  <span data-id="reason"> <Translate value={`document.remind.description.reason.${reminder.reason}`}/></span>
                </span>
              </div>
            </div>
            <div className="row">
              <div className="col-12 my-2">
                <span>
                  <strong><Translate value="document.remind.description.additionalContext"/></strong>
                  <span data-id="additionalContext"> {reminder.additionalContext}</span>
                </span>
              </div>
            </div>
          </div>
          <hr className="mt-4 mb-2"/>
          <div style={{minHeight: 200, position: 'relative'}}>
            {props.loading && <div className="loading-overlay"/>}
            <ReadOnlyDocumentsList
              documents={props.documents}
              showRemindedDocumentsState
            />
          </div>
        </div>
      </Collapse>
    </div>
  );
}

ReminderView.propTypes = {
  reminder: PropTypes.object.isRequired,
  documents: PropTypes.array.isRequired,
  isOpen: PropTypes.bool,
  loading: PropTypes.bool,
  onOpenReminder: PropTypes.func.isRequired
};

export default ReminderView;
